import { cn } from '@newfront-insurance/core-ui/v2';
import { motion } from 'framer-motion';
import type { ComponentPropsWithoutRef } from 'react';

import { novaGradientClass } from '../../../design-system/gradients';

export function ToolHandoffCard({ className, children, ...props }: ComponentPropsWithoutRef<'div'>) {
  return (
    <div className={cn('w-full rounded-[16px] p-px', novaGradientClass.aiBorderIcon, className)} {...props}>
      {children}
    </div>
  );
}

export function ToolHandoffCardSurface({ className, ...props }: ComponentPropsWithoutRef<typeof motion.div>) {
  return <motion.div className={cn('bg-wtw-infinity-10 flex w-full flex-col rounded-[15px]', className)} {...props} />;
}

export function ToolHandoffCardHeader({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('flex items-start justify-between gap-6 px-[30px] py-5', className)} {...props} />;
}

export function ToolHandoffCardBody({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('border-steel-75 border-t border-solid px-[15px] pt-[10px]', className)} {...props} />;
}

export function ToolHandoffCardFooter({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('flex items-center justify-between px-[27px] py-5', className)} {...props} />;
}
